(function(angular) {
    'use strict';

    var module = angular.module('core');

    module.controller('onvio.shell.MainController',
        [
            '$rootScope',
            '$scope',
            '$cookies',
            '$state',
            '$timeout',
            '$http',
            '$window',
            '$document',
            '$q',
            '$uibModal',
            '$translate',
            'fef.Utils',
            'bmAccess',
            'bmPermission',
            'bluemoon.components.Notifications',
            'operationAlertDisplayModalService',
            'uploadAlertDisplayModalService',
            'dmsUploadService',
            'dmsApiOperationService',
            'DmsAlertModel',
            '$location',
            '$bentoSkipLinks',
            'AuthenticatedSessionData',
            'bm.practice.timeAndExpense.userPreferences.CurrentUserPreferencesTimeAndExpenseEntryService',
        function(
            $rootScope,
            $scope,
            $cookies,
            $state,
            $timeout,
            $http,
            $window,
            $document,
            $q,
            $uibModal,
            $translate,
            utils,
            bmAccess,
            bmPermission,
            notifications,
            operationAlertDisplayModalService,
            uploadAlertDisplayModalService,
            dmsUploadService,
            dmsApiOperationService,
            DmsAlertModel,
            $location,
            $bentoSkipLinks,
            sessionData,
        userService) {
            $scope.userPreferences = {};
            $scope.pageTitle = '';
            const RETRIES = 15;
            const TIMEOUT_DELAYS = {
                default: 1000,
                extendedDelay: 2000,
                reload:2500
            };

            $scope.getPageTitle = function() {
                return $scope.pageTitle;
            };

            // From DMS's dmsMain controller
            $scope.isLoading = false;

            $scope.$on('toggleLoadingIndicator', function() {
                $scope.isLoading = !$scope.isLoading;
                window.setLoadingIndicator($scope.isLoading);
            });
            $scope.$on('getUserPreferencesFromNS', function(event, callback) {
                userService.get().then(preferences => {
                    callback(preferences);
                }).catch(() => {
                    callback(null);
                });
                                });

            $scope.showTitleBar = false;
            $scope.hasBrErroMessage = false;
            $scope.bentoBoxShadow = '0';
            $scope.operations = dmsApiOperationService.operations;
            $scope.operationBatch = dmsApiOperationService.currentBatch;
            $scope.totalUploads = dmsUploadService.totalProgress;
            $scope.uploads = dmsUploadService.uploads;

            $scope.unifiedProfileAccess = null;

            // Define if should show the new profile layout
            $scope.showNewProfile = false;
            $scope.showNewProfileExceptBR = false;
            $scope.loadedHeader = false;

            $scope.isHybridCookieComponentInitialized = false;
            $scope.isBRDashboardPage = $location.path().includes('dashboard-core-center');
            $scope.auth0Disabled = false;

            bmAccess.has('Platform_UnifiedProfile').then(function() {
                $scope.unifiedProfileAccess = true;
            }).catch(angular.noop);

            bmAccess.has('Platform_NewProfilePanel').then(function() {
                $scope.showNewProfile = true;
                $scope.loadedHeader = true;
            }).catch(function() {
                bmPermission.has('OnvioBR.PlatformNewProfilePanel').then(function() {
                    $scope.showNewProfile = true;
                }).finally(function() {
                    $scope.loadedHeader = true;
                });
            });

            bmAccess.has('Platform_NewNotificationPanel').then(function() {
                $scope.showNewProfileExceptBR = true;
            }).catch(function() {
                $scope.showNewProfileExceptBR = false;
            });

            bmAccess.not('DisableCustomPageTitle').then(function(hasPermission) {
                $scope.hasPageTitleIAC = hasPermission;
            }).catch(function(error) {
                $scope.hasPageTitleIAC = false;
                console.error(error);
            });

            bmAccess.has('Platform_DisableAuth0Phase2').then(function() {
                $scope.auth0Disabled = true;
            }).catch(function(){
                $scope.auth0Disabled = false;
            });

            bmAccess.has('BR_EnableGenericDocumentAlertErrorWithSupportLink').then(function() {
                $scope.hasBrErroMessage = true;
                sessionData.getBindings().then(function(bindings) {
                    $scope.onvioBrSupportLink = bindings.RoutingTable.OnvioBRSupport;
                });
            }).catch(angular.noop);

            $scope.$on('dms-operation-complete', function(event, operationModel) {
                $timeout(function(){
                    $scope.operations.remove(operationModel);
                }, 2500);
            });

            $scope.$on('dms-operation-batch-complete', function(){
                if (dmsApiOperationService.currentBatch.error === 0) {
                    $timeout(function(){
                        if (!dmsApiOperationService.operationQueue.isProcessing()) {
                            dmsApiOperationService.clearBatch();
                        }
                    }, 2500);
                }
            });

            // NOTE: TEMPORARY HACK FOR TITLE BAR DISPLAY
            $scope.$on('SetTitleBar', function() {
                $scope.showTitleBar = true;
                $scope.bentoBoxShadow = 'none';
            });

            $scope.getTranslations = function() {
                $translate('Onvio.Shell.Title').then(function(translation) {
                    $scope.pageTitle = translation;
                });
                $translate('Bluemoon.Shell.Navigation.SkipToMain').then(function(translatedString){
                    $scope.links = [
                        {
                            'anchor': 'maincontent',
                            'text': translatedString,
                            'isHashAnchor': false
                        }];
                    $bentoSkipLinks.updateLinks($scope.links);
                });
            };

            $scope.handleHybridCookieInitialized = function() {
                this.isHybridCookieComponentInitialized = true;
                $scope.$apply();
            };

            function isNavTitleFound(data) {
                const newValue = data.newValue;
                const url = $location.url();
                const isProjectsScreen = newValue.indexOf($translate.instant('Bluemoon.Core.Setup.Clients.Detail.Navigation.Projects')) === 0;
                const isSetupScreen = newValue.indexOf($translate.instant('Bluemoon.Shell.Navigation.Setup')) === 0;
                const isReportsScreen = newValue.indexOf($translate.instant('Bluemoon.Shell.Navigation.Reports')) === 0;
                const isTimeAndBillingScreen = newValue.indexOf($translate.instant('Bluemoon.Shell.Navigation.TimeAndBilling')) === 0 &&
                    (url.includes('time-and-expense') || url.includes('billing') || url.includes('receipt-and-adjustment'));

                return isProjectsScreen || isSetupScreen || isReportsScreen || isTimeAndBillingScreen;
                }

            $rootScope.$on('bmNavDocumentTitleBeforeChange', function(evt, data) {
                var result = false;
                if ($scope.hasPageTitleIAC) {
                     result = isNavTitleFound(data);
                }
                // override all title changes for Documents screens and the Client Dashboard
                if ( result ||
                    data.newValue.indexOf($translate.instant('Bluemoon.Shell.Navigation.Documents')) === 0 ||
                    data.newValue.indexOf($translate.instant('Bluemoon.Shell.Navigation.ClientDashboard')) === 0 ||
                    (data.newValue.indexOf($translate.instant('Bluemoon.Shell.Navigation.Dashboard')) === 0) &&
                    $location.url().includes('client-dashboard')) {
                    data.cancel = true;
                }
            });

            $rootScope.$on('$locationChangeSuccess', function() {
                let canRunNewImplementation; const url = $location.url();
                if (isNewPageTitleRequired()) {
                    canRunNewImplementation = false;
                    if (url.includes('documents/request-templates') || url.includes('documents/templates')) { canRunNewImplementation = true; }
                    if (!canRunNewImplementation) { return; }
                }
                if ($document[0]){
                    if (!$location.url().includes('combine') && $document[0].title.includes($translate.instant('Bluemoon.DMS.CombineDocumentsPage.Title'))) {
                        $document[0].title = $scope.pageTitle;
                    }
                    $scope.pageTitle = $document[0].title;
                    if ($scope.hasPageTitleIAC) {
                        let delay = getTimeoutDelayBasedOnLocation(url);
                        $timeout(function() {
                            updatePageTitle(RETRIES);
                        }, delay);
                    }
                }
            });
            function updatePageTitle(retries) {
                try {
                    var isWorkSpaceOpened = document.querySelector('bm-modal-ui-view') ? document.querySelector('bm-modal-ui-view').getAttribute('newmodal') : false;
                    if (!$scope.hasPageTitleIAC) { return; }
                    if (isWorkSpaceOpened) {
                        return;
                    }
                    var header = getHeader();
                    let unspecifiedHeader = $translate.instant('Bluemoon.Core.Setup.Common.DefaultDisplayAs');
                        if (header  && !header.includes(unspecifiedHeader)) {
                            $document[0].title = header + ' | ' +  $translate.instant('Onvio.Shell.Title');
                            document.querySelector('#CD-page-title-announcement').innerHTML = $document[0].title;
                            $scope.pageTitle = $document[0].title;
                        } else if (retries > 0) {
                            $timeout(function() {
                                updatePageTitle(retries - 1);
                            }, 100);
                        } else {
                            $document[0].title = $translate.instant('Onvio.Shell.Title');
                            document.querySelector('#CD-page-title-announcement').innerHTML = $document[0].title;
                            $scope.pageTitle = $document[0].title;
                    }
                    } catch (error) {
                        console.error('Error updating page title:', error);
                    }
            }
            function getHeader() {
                if($location.url().includes('setup/firm-settings')) {
                    let header = document.querySelector('staff-saf-text');
                    return header ? header.textContent.trim() : null;
                }
                var headerElement = $document[0].querySelector('h1');
                return headerElement ? headerElement.textContent.trim() : null;
            }
            $scope.$watch(getHeader, function(newvalue, oldvalue) {
                if ($location.url().includes('time-and-expense/entry')) {
                   if(newvalue !== oldvalue) {
                       updatePageTitle(RETRIES);
                   }
                }
             });
            function getTimeoutDelayBasedOnLocation(url) {
                if (url.includes('firm-management-reports-options-add') || url.includes('billing/detail')) {
                    return TIMEOUT_DELAYS.extendedDelay;
                }
                return TIMEOUT_DELAYS.default;
            }
            function isNewPageTitleRequired() {
                const url = $location.url();
                return url.includes('activity') || url.includes('firm-dashboard') ||
                    url.includes('client-dashboard') || url.includes('documents');
            }

            $scope.$on('changeTitleOnTabClicked', function(event, tabs) {
                try {
                    if (!$scope.hasPageTitleIAC) { return; }
                    const tabLabels = [
                        $translate.instant('Core.Captions.Invoice.SummaryExpenses'),
                        $translate.instant('Core.Captions.Invoice.SummaryTime'),
                        $translate.instant('Bluemoon.ReceiptAndAdjustment.DailyEntry.AdjustmentsTab'),
                        $translate.instant('Bluemoon.ReceiptAndAdjustment.DailyEntry.ReceiptsTab')
                    ];
                    if (tabs && tabs.label && tabLabels.includes(tabs.label)) {
                        $timeout(function() {
                            if ($document[0]) {
                                updatePageTitle(10);
                            }
                        }, TIMEOUT_DELAYS.default);
                    }
                     } catch (error) { console.error('Error at changeTitleOnTabClicked:', error); }
            });

            $scope.$on('pageTitleUpdate', function(event, data) {
                var newTitle = '';
                var dataRootType = '';
                if(data.type) {
                    var dataType = data.type.toLowerCase();
                    dataRootType = data.rootType ? data.rootType.toLowerCase() : '';
                    if (dataType === 'firmtaxandaccountinglibrary' || (dataType === 'folders' && dataRootType === 'firmtaxandaccountinglibrary')) {
                        newTitle = $translate.instant('Bluemoon.DMS.SpecialFolders.FirmDocuments');
                    }  else if (dataType === 'mytaxandaccountinglibraries' || (data.type === 'folders' && dataRootType === 'mytaxandaccountinglibraries')) {
                        newTitle = $translate.instant('Bluemoon.DMS.SpecialFolders.MyDocuments');
                    } else if (dataType === 'folders' && data.primaryAssociationName) {
                        newTitle = data.primaryAssociationName + ' | ' + $translate.instant('Bluemoon.DMS.SpecialFolders.Clients');
                    }
                } else if (data.itemType) {
                    var dataItemType = data.itemType.toLowerCase();
                    dataRootType = data.rootType ? data.rootType.toLowerCase() : '';
                    if (dataItemType === 'folder') {
                        if (dataRootType === 'firmtaxandaccountinglibrary') {
                            newTitle = $translate.instant('Bluemoon.DMS.SpecialFolders.FirmDocuments');
                            if (data.item) {
                                newTitle = data.item.name + ' | ' + newTitle;
                            }
                        }  else if (dataRootType === 'mytaxandaccountinglibraries') {
                            newTitle = $translate.instant('Bluemoon.DMS.SpecialFolders.MyDocuments');
                            if (data.item) {
                                newTitle = data.item.name + ' | ' + newTitle;
                            }
                        } else if (data.primaryAssociationName) {
                            newTitle = data.primaryAssociationName + ' | ' + $translate.instant('Bluemoon.DMS.SpecialFolders.Clients');
                            if (data.item) {
                                newTitle = data.item.name + ' | ' + newTitle;
                            }
                        }
                    } else if (dataItemType === 'treeview' && data.drawer === 'Client') {
                        newTitle = $translate.instant('Bluemoon.DMS.SpecialFolders.Clients');
                    } else if (dataItemType === 'treeview' && data.drawer === 'My') {
                        newTitle = $translate.instant('Bluemoon.DMS.SpecialFolders.MyDocuments');
                    } else if (dataItemType === 'treeview' && data.drawer === 'Firm') {
                        newTitle = $translate.instant('Bluemoon.DMS.SpecialFolders.FirmDocuments');
                    } else if (dataItemType === 'clientslist') {
                        newTitle = $translate.instant('Bluemoon.DMS.SpecialFolders.Clients');
                    } else if (dataItemType === 'client') {
                        newTitle = data.containerName + ' | ' + $translate.instant('Bluemoon.DMS.SpecialFolders.Clients');
                    } else if (dataItemType === 'clientdashboard') {
                        newTitle = data.containerName + ' | ' + $translate.instant('Bluemoon.Shell.Navigation.ClientDashboard');
                    } else if (dataItemType === 'project') {
                        newTitle = data.primaryAssociationName + ' | ' + $translate.instant('Bluemoon.DMS.SpecialFolders.Clients');
                        if (data.item) {
                            newTitle = data.item.name + ' | ' + newTitle;
                        }
                    } else if (dataItemType === 'alldoclist') {
                        newTitle = $translate.instant('Onvio.Shell.Navigation.Documents');
                    } else if (dataItemType === 'approvalslist') {
                        newTitle = $translate.instant('Bluemoon.DMS.SpecialFolders.Approvals');
                    } else if (dataItemType === 'communicationslist') {
                        newTitle = $translate.instant('Bluemoon.DMS.SpecialFolders.Communications');
                    } else if (dataItemType === 'requestslist') {
                        newTitle = $translate.instant('Bluemoon.DMS.SpecialFolders.Requests');
                    } else if (dataItemType === 'searchlist') {
                        newTitle = $translate.instant('Bluemoon.DMS.Title.SearchResults');
                    } else if (dataItemType === 'recentslist') {
                        newTitle = $translate.instant('Bluemoon.DMS.SpecialFolders.DocumentActivity');
                    } else if (dataItemType === 'legacyrecentslist') {
                        newTitle = $translate.instant('Bluemoon.DMS.SpecialFolders.Recents');
                    } else if (dataItemType === 'recyclelist') {
                        newTitle = $translate.instant('Bluemoon.DMS.SpecialFolders.RecycleBin') ;
                    }
                }
                $scope.pageTitle = newTitle !== '' ? newTitle + ' | ' + $translate.instant('Onvio.Shell.Title') : $translate.instant('Onvio.Shell.Title');
            });
            $rootScope.$on('reloadEvent', function() {
                if ($document[0].title === $translate.instant('Onvio.Shell.Title')) {
                    updatePageTitle(RETRIES);
                }
            });

            $rootScope.$on('$translateChangeEnd', function() {
                $timeout(function() {
                    $rootScope.$emit('reloadEvent');
                }, TIMEOUT_DELAYS.reload);
                $scope.getTranslations();
            });

            $scope.getTranslations();

            notifications.alertStream().subscribe(function(alert) {
                if(!utils.exists(alert)) {
                    $scope.closeBmErrorAlert();
                } else {
                    $scope.bmErrorModel = new DmsAlertModel({
                        status: alert.type,
                        message: alert.message
                    });
                    $timeout(function() {
                        if ($scope.bmErrorModel !== null) {
                            $scope.bmErrorModel = null;
                        }
                    }, 7000);
                }
            });

            $scope.openUploadAlertDisplayModal = function() {
                if ($scope.totalUploads.totalFiles > 0 && !$scope.dialogOpen) {
                   uploadAlertDisplayModalService.open({ uploadCollection: $scope.uploads })
                        .then(function(uploadAlertDisplayModalInstance) {
                            if (uploadAlertDisplayModalInstance) {
                                $scope.dialogOpen = true;
                                uploadAlertDisplayModalInstance.result.then(function() {
                                    $scope.dialogOpen = false;
                                });
                            }

                            var unregisterTotalFilesWatch = $scope.$watch('totalUploads.totalFiles', function(newValue) {
                                if (newValue === 0) {
                                    uploadAlertDisplayModalInstance.close();
                                    unregisterTotalFilesWatch();
                                }
                            });
                        });
                }
            };

            $scope.openOperationAlertDisplayModal = function() {
                if ($scope.operations.length > 0 && !$scope.dialogOpen) {
                    operationAlertDisplayModalService.open({ dmsOperationCollectionModel: $scope.operations })
                        .then(function(operationAlertDisplayModalInstance) {
                            var unregisterOperationsLengthWatch = $scope.$watch('operations.length', function(newValue) {
                                if (newValue === 0) {
                                    operationAlertDisplayModalInstance.close();
                                    unregisterOperationsLengthWatch();
                                }
                            });

                            if (operationAlertDisplayModalInstance) {
                                $scope.dialogOpen = true;
                                operationAlertDisplayModalInstance.result.then(function() {
                                    unregisterOperationsLengthWatch();
                                    $scope.dialogOpen = false;
                                });
                            }
                        });
                }
            };

            $scope.getFirstUpload = function() {
                var uploadKeys = Object.keys(dmsUploadService.uploads);
                if (uploadKeys.length > 0) {
                    return dmsUploadService.uploads[_.sortBy(uploadKeys, function(key) {
                        return key.substr(key.lastIndexOf('|') + 1);
                    }).reverse()[0]];
                }
            };

            $scope.closeBmErrorAlert = function() {
                $scope.bmErrorModel = null;
            };

            $scope.$on('$stateChangeSuccess', function() {
                $scope.closeBmErrorAlert();

                // hack to get dashboard styling correct compared to other views
                $scope.isDashboard = $state.current.name === 'firm-dashboard';

                $scope.isReportDocuments = $state.current.name === 'employee-portal-documents';
            });

            $rootScope.$watchCollection('bmErrors', function(newValue, oldValue) {
                if (newValue !== oldValue && !$scope.bmErrorModel) {
                    if ($scope.hasBrErroMessage) {
                        getSessionToken().then(function(res) {
                            var supportLink = $scope.onvioBrSupportLink += '?token=' + res.token + '&uri=/sgsc/faces/cad-ssc.html';
                            var errorMessage = $translate.instant('StaffApp.DMS.ErrorMessage.BRServerError', { supportLink: supportLink });
                            $scope.bmErrorModel = new DmsAlertModel({
                                status: 'warning',
                                message: errorMessage
                            });
                        });
                    } else {
                        var bmError = newValue.shift();
                        if (bmError) {
                            $scope.bmErrorModel = new DmsAlertModel({
                                status: 'error',
                                message: bmError.msg
                            });
                        }
                    }
                }
            });

            bmAccess.has('Brazil_ProfilePanelEnableCloseButton').then(function() {
                assignNotificationCloseEvent();
            }).catch(angular.noop);

            function triggerPurchaseConfirmationIfNeeded() {
                if ($location.search().purchaseConfirmation) {
                    showPurchaseConfirmation();
                } else {
                    triggerSetupWidgetIfNeeded();
                }
            }

            function showPurchaseConfirmation() {
                var tourModal = $uibModal.open({
                    templateUrl: 'views/main/purchase-confirmation.html',
                    controllerAs: 'conf',
                    backdrop: 'static',
                    keyboard: false,
                    windowClass: 'purchase-confirmation-modal',
                    controller: function() {
                        this.getStarted = function() {
                            tourModal.dismiss();
                            $location.search('purchaseConfirmation', null);
                            triggerSetupWidgetIfNeeded();
                        };
                    }
                });
            }

            triggerPurchaseConfirmationIfNeeded();

            function triggerSetupWidgetIfNeeded() {
                $q.all([bmAccess.has('PlatformSetupQuestionnaire'), bmPermission.has('Platform.SetupQuestionnaire')]).then(function() {
                    getCompanyId().then(function(companyId) {
                        var url = '/api/profiles/v1/companies/' + companyId + '/preferences';
                        return getSetupWidgetPref(url).then(function(res) {
                            if(res.length === 0) {
                                showSetupWidget();
                            } else {
                                if(res[0].value.completed !== 'true') {
                                    showSetupWidget();
                                } else {
                                    triggerOnboardingTourIfNeeded();
                                }
                            }
                        });
                    }).catch(angular.noop);
                }).catch(function() {
                    triggerOnboardingTourIfNeeded();
                });
            }

            function showSetupWidget() {
                $translate(['onvio.setup.widget.error.submit.required']).then(function(strings) {
                    var setupModal = $uibModal.open({
                        templateUrl: 'views/main/setup-widget.html',
                        controllerAs: 'set',
                        backdrop: 'static',
                        keyboard: false,
                        windowClass: 'setup-modal',
                        controller: function() {
                            this.accounting = false;
                            this.atestation = false;
                            this.payroll = false;
                            this.individual_tax = false;
                            this.business_tax = false;
                            this.consulting = false;
                            this.onFirmnameFocus = function() {
                                this.firmname = false;
                            };
                            this.onFirmnameBlur = function() {
                                if (this.firmnameValue) {
                                    this.returnedFirmname = this.firmnameValue;
                                    this.firmname = false;
                                    this.firmnameComplete = true;
                                } else {
                                    this.firmname = true;
                                    this.returnedFirmname = '';
                                    this.firmnameComplete = false;
                                }
                            };
                            this.onStaffChange = function() {
                                if (this.staffyes) {
                                    this.returnedStaff = 'Yes';
                                } else {
                                    this.returnedStaff = 'No';
                                }
                                this.staffComplete = true;
                            };
                            this.onServicesChange = function() {
                                if (this.accounting || this.attestation || this.payroll || this.individual_tax || this.business_tax || this.consulting) {
                                    this.servicesComplete = true;
                                } else {
                                    this.servicesComplete = false;
                                }
                                var serviceLabels = ['accounting', 'attestation', 'payroll', 'individual_tax', 'business_tax', 'consulting'];
                                var serviceItems = [];
                                for (var i = 0; i < serviceLabels.length; i++) {
                                    if (this[serviceLabels[i]]) {
                                        serviceItems.push(serviceLabels[i]);
                                    }
                                }
                                serviceItems = serviceItems.toString();
                                this.returnedServices = serviceItems;
                            };
                            this.done = function() {
                                if (!this.firmnameComplete || !this.servicesComplete || !this.staffComplete) {
                                    this.setupWidgetFormAlert = [{
                                        type: 'danger',
                                        msg: strings['onvio.setup.widget.error.submit.required'],
                                        closeable: true,
                                        timeout: 2500
                                    }];
                                } else {
                                    var pref = {};
                                    var broadcast = {};
                                    broadcast.firmName = this.returnedFirmname;
                                    broadcast.staff = this.returnedStaff;
                                    broadcast.service = this.returnedServices;
                                    pref.application = 'onvio';
                                    pref.category = 'setupWidget';
                                    pref.value = broadcast;
                                    pref.value.completed = 'true';
                                    $scope.$broadcast('bmUpdateCompanyStaffServices', broadcast);
                                    getCompanyId().then(function(companyId) {
                                        var url = '/api/profiles/v1/companies/' + companyId + '/preferences';
                                        setSetupWidgetPref(url, pref);
                                    });
                                    setCompanyName(this.returnedFirmname);
                                    setupModal.dismiss();
                                    triggerOnboardingTourIfNeeded();
                                }
                            };
                        }
                    });
                });
            }

            function getSetupWidgetPref(url) {
                return $http({
                    method: 'GET',
                    url: url,
                    params: {
                        application: 'onvio',
                        category: 'setupWidget'
                    }
                }).then(function(res) {
                    return res.data;
                });
            }

            function setSetupWidgetPref(url, pref) {
                getSetupWidgetPref(url).then(function(res) {
                    if (res.length === 0) {
                        return $http({
                            method: 'POST',
                            url: url,
                            data: pref
                        }).then(function(res) {
                            return res.data;
                        });
                    } else {
                        return $http({
                            method: 'PUT',
                            url: url + '/' + res[0].id,
                            data: pref
                        }).then(function(res) {
                            return res.data;
                        });
                    }
                });
            }

            function getCompanyId() {
                return $http({
                    method: 'GET',
                    url: '/api/security/v1/session-bindings'
                }).then(function(res){
                    return res.data.ApplicationConfiguration.CompanyId;
                });
            }

            function getContactId(companyId) {
                return $http({
                    method: 'GET',
                    url: '/api/core/v1/companies/' + companyId + '/main'
                }).then(function(res){
                    return $http({
                        method: 'GET',
                        url: '/api/core/v3/companies/' + companyId + '/clients/' + res.data.companyClient.id,
                        params: {
                            expand: 'primaryContactExpanded,primaryContactExpanded.nationalIdentitiesExpanded,primaryContactExpanded.contactImageExpanded,clientMainExpanded'
                        }
                    }).then(function(resp){
                        return resp.data.primaryContact.id;
                    });
                });
            }

            function setCompanyName(firmName) {
                getCompanyContact().then(function(res) {
                    var companyId = res.companyId;
                    var contactId = res.contactId;
                    res.data.fullName = firmName;
                    res.data.displayAs = firmName;
                    $http({
                        method: 'PUT',
                        url: '/api/core/v4/companies/' + companyId + '/contacts/' + contactId,
                        data: res.data
                    });
                });
            }

            function getSessionToken() {
                return $http({
                    method: 'POST',
                    url: '/api/security/v1/jwt/sessions',
                }).then(function(res) {
                    return res.data;
                });
            }

            function getCompanyContact() {
                return getCompanyId().then( function(companyId) {
                    return getContactId(companyId).then(function(contactId) {
                        return $http({
                            method: 'GET',
                            url: '/api/core/v4/companies/' + companyId + '/contacts/' + contactId
                        }).then(function(res){
                            var companyContact = {};
                            companyContact.companyId = companyId;
                            companyContact.contactId = contactId;
                            companyContact.data = res.data;
                            return companyContact;
                        });
                    });
                });
            }

             /* PREVIEW TOUR */
            // TODO: Switch duplicate default tour to spearhead tour when designed
            var previewTourData, previewTourPaused = false, previewL10nStrings = '';

            function triggerPreviewTourIfNeeded() {
                // make sure we have tour access and preview permission
                $q.all([bmPermission.has('Applications.Onvio'), bmPermission.has('Platform.PreviewMode')])
                    .then(function() {
                        if ($window.sessionStorage.getItem('bmPreviewTour') === null) {
                            startPreviewTour();
                        }
                    }).catch(angular.noop);
            }
            function startPreviewTour() {
                $translate([
                    'onvio.tour.nextbtn',
                    'onvio.tour.donebtn',
                    'onvio.tour.dismisslink',
                    'onvio.tour.progresslabel',
                    'onvio.dashboard.tour.step1.title',
                    'onvio.dashboard.tour.step1.content',
                    'onvio.dashboard.tour.step2.title',
                    'onvio.dashboard.tour.step2.content',
                    'onvio.dashboard.tour.step3.title',
                    'onvio.dashboard.tour.step3.content',
                    'onvio.dashboard.tour.step4.title',
                    'onvio.dashboard.tour.step4.content',
                    'onvio.dashboard.tour.step5.title',
                    'onvio.dashboard.tour.step5.content',
                    'onvio.dashboard.tour.step6.title',
                    'onvio.dashboard.tour.step6.content',
                    'onvio.dashboard.tour.step7.title',
                    'onvio.dashboard.tour.step7.content',
                    'onvio.dashboard.tour.step8.title',
                    'onvio.dashboard.tour.step8.content'
                ]).then(function(l10n) {
                    previewL10nStrings = l10n;
                    previewTourData = {
                        id: 'dashboard-tour',
                        onStart: function() {
                            if (!previewTourPaused) {
                                tourSetup();
                                addOverlay();
                                previewStepSetup();
                            }
                        },
                        onNext: function() {
                            if (!previewTourPaused) {
                                previewStepSetup();
                            }
                        },
                        onEnd: function() {
                            if (!previewTourPaused) {
                                removeOverlay();
                                savePreviewTourPref();
                            }
                        },
                        onClose: function() {
                            if (!previewTourPaused) {
                                removeOverlay();
                                savePreviewTourPref();
                            }
                        },
                        i18n: {
                            nextBtn: l10n['onvio.tour.nextbtn'],
                            doneBtn: l10n['onvio.tour.donebtn']
                        },
                        steps: [
                            // skipped if target is not found in DOM i.e. no permission
                            {
                                title: l10n['onvio.dashboard.tour.step1.title'],
                                content: l10n['onvio.dashboard.tour.step1.content'],
                                target: 'projects-widget',
                                placement: 'top',
                                yOffset: 20
                            },
                            {
                                title: l10n['onvio.dashboard.tour.step2.title'],
                                content: l10n['onvio.dashboard.tour.step2.content'],
                                target: 'staff-widget',
                                placement: 'top',
                               yOffset: 20
                            },
                            {
                                title: l10n['onvio.dashboard.tour.step3.title'],
                                content: l10n['onvio.dashboard.tour.step3.content'],
                                target: 'bm-header-app-menu-toggle',
                                placement: 'bottom',
                                xOffset: -195,
                                arrowOffset: 200,
                                fixedElement: true,
                                yOffset: -10,
                                onShow: openHeaderAppMenu,
                                onNext: previewCloseHeaderAppMenu
                            },
                            {
                                title: l10n['onvio.dashboard.tour.step4.title'],
                                content: l10n['onvio.dashboard.tour.step4.content'],
                                target: 'client-dashboard',
                                placement: 'bottom',
                                fixedElement: true
                            },
                            {
                                title: l10n['onvio.dashboard.tour.step5.title'],
                                content: l10n['onvio.dashboard.tour.step5.content'],
                                target: 'documents',
                                placement: 'bottom',
                                fixedElement: true
                            },
                            {
                                title: l10n['onvio.dashboard.tour.step6.title'],
                                content: l10n['onvio.dashboard.tour.step6.content'],
                                target: 'projects',
                                placement: 'bottom',
                                fixedElement: true
                            },
                            {
                                title: l10n['onvio.dashboard.tour.step7.title'],
                                content: l10n['onvio.dashboard.tour.step7.content'],
                                target: 'timeAndBilling',
                                placement: 'bottom',
                                fixedElement: true
                            },
                            {
                                title: l10n['onvio.dashboard.tour.step8.title'],
                                content: l10n['onvio.dashboard.tour.step8.content'],
                                target: 'bm-header-help-dropdown',
                                placement: 'left',
                                fixedElement: true
                            },
                        ]
                    };

                    var langCode = $cookies.get('BMLanguageCode').slice(0,2);

                    $scope.tourModal = $uibModal.open({
                        templateUrl: 'views/main/preview-tour.html',
                        keyboard: false,
                        backdrop: 'static',
                        controllerAs: 'conf',
                        controller: function() {
                            this.startTour = function() {
                                $scope.tourModal.dismiss();
                                // switch to dashboard
                                $state.go('firm-dashboard').then(function() {
                                    // wait till next cycle, otherwise dashboard steps not found
                                    $timeout(function() {
                                        $window.hopscotch.startTour(previewTourData, 0); // always start at step 0
                                    }, 1000);
                                });
                            };
                            this.noThanks = function() {
                                $scope.tourModal.dismiss();
                                savePreviewTourPref();
                            };
                            this.fr = langCode === 'fr' ? true : false;
                            this.previewTerms = 'https://www.thomsonreuters.ca/' + langCode + '/onvio/trial-terms.html';
                        }
                    });
                });
            }
            function savePreviewTourPref() {
                $window.sessionStorage.setItem('bmPreviewTour', 'true');
            }

            $rootScope.$on('bmLanguageChangeSuccess', function() {
              if ($scope.tourModal) {
                $scope.tourModal.dismiss();
              }
              triggerPreviewTourIfNeeded();
            });

            /* STAFF ONBOARDING TOUR */
            // TODO: move getting/setting the enable/disable state to userprefs-global service
            var defaultTourPref = { application: 'onvio', category:'global', value: {} };

            var tourPrefRoute = '/api/profiles/v1/preferences';
            var onvioGlobalPrefConfig = { params: { application: 'onvio', category: 'global' } };
            var tourData, tourPaused = false, l10nStrings;

            function triggerOnboardingTourIfNeeded(force) {
                // make sure we have tour access and dashboard permission
                $q.all([bmAccess.has('StaffHomeOnboardingTour'), bmPermission.has('Applications.Onvio'), bmPermission.not('Platform.PreviewMode')])
                    .then(function()  {
                        return $http.get(tourPrefRoute, onvioGlobalPrefConfig).then(function(resp) {
                            var pref = resp.data[0]; // assume one or zero prefs

                            if (tourEnabled(force, pref)) {
                                startOnboardingTour(pref);
                            }

                            function tourEnabled(force, pref) {
                                // dashboardTour preference exists to disable tour
                                return force || !pref || !pref.value || !pref.value.dashboardTour || delayedTourEnabled(pref.value.dashboardTour);

                                function delayedTourEnabled(dashboardTourPref) {
                                    // enabled if delayed 12>=hrs ago
                                    var delay = 43200000; // 12 hrs
                                    return (dashboardTourPref.delayed && Date.now() - dashboardTourPref.timestamp >= delay);
                                }
                            }
                        });
                    }).catch(angular.noop);
            }
            function startOnboardingTour(pref) {
                pref = pref || angular.copy(defaultTourPref);

                $translate([
                    'onvio.tour.nextbtn',
                    'onvio.tour.donebtn',
                    'onvio.tour.dismisslink',
                    'onvio.tour.progresslabel',
                    'onvio.dashboard.tour.step1.title',
                    'onvio.dashboard.tour.step1.content',
                    'onvio.dashboard.tour.step2.title',
                    'onvio.dashboard.tour.step2.content',
                    'onvio.dashboard.tour.step3.title',
                    'onvio.dashboard.tour.step3.content',
                    'onvio.dashboard.tour.step4.title',
                    'onvio.dashboard.tour.step4.content',
                    'onvio.dashboard.tour.step5.title',
                    'onvio.dashboard.tour.step5.content',
                    'onvio.dashboard.tour.step6.title',
                    'onvio.dashboard.tour.step6.content',
                    'onvio.dashboard.tour.step7.title',
                    'onvio.dashboard.tour.step7.content',
                    'onvio.dashboard.tour.step8.title',
                    'onvio.dashboard.tour.step8.content'
                ]).then(function(l10n) {
                    l10nStrings = l10n;
                    tourData = {
                        id: 'dashboard-tour',
                        onStart: function() {
                            if (!tourPaused) {
                                tourSetup();
                                addOverlay();
                                stepSetup();
                            }
                        },
                        onNext: function() {
                            if (!tourPaused) {
                                stepSetup();
                            }
                        },
                        onEnd: function() {
                            if (!tourPaused) {
                                removeOverlay();
                                saveOnboardingTourPref(pref, {completed: true});
                            }
                        },
                        onClose: function() {
                            if (!tourPaused) {
                                removeOverlay();
                                saveOnboardingTourPref(pref, {dismissed: true});
                            }
                        },
                        i18n: {
                            nextBtn: l10n['onvio.tour.nextbtn'],
                            doneBtn: l10n['onvio.tour.donebtn']
                        },
                        steps: [
                            // skipped if target is not found in DOM i.e. no permission
                            {
                                title: l10n['onvio.dashboard.tour.step1.title'],
                                content: l10n['onvio.dashboard.tour.step1.content'],
                                target: 'projects-widget',
                                placement: 'top',
                                yOffset: 20
                            },
                            {
                                title: l10n['onvio.dashboard.tour.step2.title'],
                                content: l10n['onvio.dashboard.tour.step2.content'],
                                target: 'staff-widget',
                                placement: 'top',
                                yOffset: 20
                            },
                            {
                                title: l10n['onvio.dashboard.tour.step3.title'],
                                content: l10n['onvio.dashboard.tour.step3.content'],
                                target: 'bm-header-app-menu-toggle',
                                placement: 'bottom',
                                xOffset: -195,
                                arrowOffset: 200,
                                fixedElement: true,
                                yOffset: -10,
                                onShow: openHeaderAppMenu,
                                onNext: closeHeaderAppMenu
                            },
                            {
                                title: l10n['onvio.dashboard.tour.step4.title'],
                                content: l10n['onvio.dashboard.tour.step4.content'],
                                target: 'client-dashboard',
                                placement: 'bottom',
                                fixedElement: true
                            },
                            {
                                title: l10n['onvio.dashboard.tour.step5.title'],
                                content: l10n['onvio.dashboard.tour.step5.content'],
                                target: 'documents',
                                placement: 'bottom',
                                fixedElement: true
                            },
                            // {
                            //     title: l10n['onvio.dashboard.tour.step6.title'],
                            //     content: l10n['onvio.dashboard.tour.step6.content'],
                            //     target: 'projects',
                            //     placement: 'bottom',
                            //     fixedElement: true
                            // },
                            {
                                title: l10n['onvio.dashboard.tour.step7.title'],
                                content: l10n['onvio.dashboard.tour.step7.content'],
                                target: 'timeAndBilling',
                                placement: 'bottom',
                                fixedElement: true
                            },
                            {
                                title: l10n['onvio.dashboard.tour.step8.title'],
                                content: l10n['onvio.dashboard.tour.step8.content'],
                                target: 'bm-header-help-dropdown',
                                placement: 'left',
                                fixedElement: true
                            },
                        ]
                    };

                    var tourModal = $uibModal.open({
                        templateUrl: 'views/main/dashboard-tour.html',
                        controllerAs: 'conf',
                        controller: function() {
                            this.startTour = function() {
                                tourModal.dismiss();
                                    // switch to dashboard
                                    $state.go('firm-dashboard').then(function() {
                                        // wait till next cycle, otherwise dashboard steps not found
                                        $timeout(function() {
                                            $window.hopscotch.startTour(tourData, 0); // always start at step 0
                                        }, 1000);
                                    });
                                };
                            this.askNextTime = function() {
                                tourModal.dismiss();
                                // dismiss for this session
                                saveOnboardingTourPref(pref, {delayed: true});
                            };
                            this.noThanks = function() {
                                tourModal.dismiss();
                                // save pref that tour was dismissed
                                saveOnboardingTourPref(pref, {dismissed: true});
                            };
                        }
                    });
                });
            }
            function saveOnboardingTourPref(pref, dashboardTour) {
                dashboardTour.timestamp = Date.now();
                return $http.get(tourPrefRoute, onvioGlobalPrefConfig).then(function(resp) {
                    var onvioGlobaPrefExists = resp.data.length > 0;

                    var onvioGlobalPref = onvioGlobaPrefExists ?
                        resp.data[0] : {application: 'onvio', category: 'global', value: {}};

                    onvioGlobalPref.value.dashboardTour = dashboardTour;

                    return onvioGlobaPrefExists ?
                        $http.put(tourPrefRoute + '/' + onvioGlobalPref.id, onvioGlobalPref) : $http.post(tourPrefRoute, onvioGlobalPref);

                });
            }
            $scope.$on('bm-reset-onboarding-tour', function() {
                var force = true;
                triggerOnboardingTourIfNeeded(force);
            });

            /*SHARED FOR STAFF ONBOARDING AND PREVIEW TOURS*/
            var doc = $window.document, el = angular.element, menuBtn, appMenu, bubble, overlay;
            function previewStepSetup() {
                $timeout(function() {
                    // override bubble close link text
                    var link = bubble.getElementsByClassName('hopscotch-close')[0];
                    if (link) {
                        link.textContent = previewL10nStrings['onvio.tour.dismisslink'];
                    }
                });
            }
            function previewCloseHeaderAppMenu() {
                // when menu anim complete, goto next step
                appMenu.addEventListener('transitionend', previewGotoNextStep, false);
                // trigger menu close
                menuBtn.triggerHandler('click');
                // cancel moving to next step
                previewTourPaused = true;
                return false;
            }
            function previewGotoNextStep() {
                // cleanup
                appMenu.removeEventListener('transitionend', previewGotoNextStep, false);
                // start back up
                $window.hopscotch.startTour(previewTourData, parseInt($window.hopscotch.getState().split(':')[1]) + 1);
                // get new bubble
                bubble = doc.getElementsByClassName('hopscotch-bubble')[0];
                previewStepSetup();
                previewTourPaused = false;
            }
            function stepSetup() {
                $timeout(function() {
                    // override bubble close link text
                    var link = bubble.getElementsByClassName('hopscotch-close')[0];
                    if (link) {
                        link.textContent = l10nStrings['onvio.tour.dismisslink'];
                    }
                });
            }
            function closeHeaderAppMenu() {
                // when menu anim complete, goto next step
                appMenu.addEventListener('transitionend', gotoNextStep, false);
                // trigger menu close
                menuBtn.triggerHandler('click');
                // cancel moving to next step
                tourPaused = true;
                return false;
            }
            function gotoNextStep() {
                // cleanup
                appMenu.removeEventListener('transitionend', gotoNextStep, false);
                // start back up
                $window.hopscotch.startTour(tourData, parseInt($window.hopscotch.getState().split(':')[1]) + 1);
                // get new bubble
                bubble = doc.getElementsByClassName('hopscotch-bubble')[0];
                stepSetup();
                tourPaused = false;
            }
            function openHeaderAppMenu() {
                // hack to update bubble's left offset (computed left offset + width of left menu)
                el(bubble).css('left', bubble.offsetLeft + appMenu.clientWidth + 'px');
                // trigger menu
                menuBtn.triggerHandler('click');
            }
            function tourSetup() {
                menuBtn = angular.element(doc.getElementsByClassName('bm-header-app-menu-toggle')[0]);
                appMenu = doc.getElementById('bm-header-app-menu');
                bubble = doc.getElementsByClassName('hopscotch-bubble')[0];
            }
            function addOverlay() {
                overlay = document.createElement('div');
                overlay.id = 'bm-tour-overlay';
                doc.body.appendChild(overlay);
            }
            function removeOverlay() {
                doc.body.removeChild(overlay);
            }
            function assignNotificationCloseEvent() {
                // closes the menu when notification's close button is pressed
                window.profileClose = document.createComment('Close event channel');

                window.profileClose.addEventListener('profile-close-channel', function() {
                    $rootScope.$emit('bmNotificationHtmlClick');
                });
            }
        }]);
}(window.angular));
